'use es6';

import { Record } from 'immutable';
import * as ViewerCache from '../utils/ViewerCache';
/* eslint-disable no-bitwise */

function UUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}
/* eslint-enable no-bitwise */


const ViewerRecord = Record({
  email: null,
  vid: null,
  uuid: null,
  consentToCommunicate: null
}, 'ViewerRecord');

ViewerRecord.createUUID = () => UUID();

ViewerRecord.create = (attrs = {}) => {
  if (!attrs.uuid) {
    return new ViewerRecord(Object.assign({}, attrs, {
      uuid: ViewerRecord.createUUID()
    }));
  }

  return new ViewerRecord(attrs);
};

ViewerRecord.createFromAuth = auth => ViewerRecord.create({
  email: auth.user.email
});

ViewerRecord.createEmpty = () => new ViewerRecord({
  uuid: ViewerRecord.createUUID()
});

ViewerRecord.getFromCache = () => {
  const cache = ViewerCache.get();

  if (!cache) {
    return null;
  }

  return ViewerRecord.create(cache);
};

ViewerRecord.hasEmail = viewer => !!(viewer.email && viewer.email.length > 0);

ViewerRecord.equals = (first, second) => !!(first.uuid && first.uuid === second.uuid || first.vid && first.vid === second.vid || first.email && first.email === second.email);

export default ViewerRecord;